/* eslint-disable no-unused-expressions */
/* eslint-disable import/no-unresolved */
import { useEffect, useState } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { Breadcrumb, BreadcrumbItem } from 'appkit-react';

import { MOVE_DIRECTORY_OR_FILE } from 'Apollo/Mutations/DataRecon';
import { GET_DIRECTORY_DETAILS } from 'Apollo/Queries/DataRecon';
import MoveFiles from '../components/MoveFiles';

const MoveFilesContainer = ({
    visible, setVisible, filesToMove, previousDir, oldFileExplorerDataSource, refreshFileExplorer, setToastMessage,
}) => {
    const [currentDir, setCurrentDir] = useState(null);
    // state for file explorer
    const [selection, setSelection] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [sameFolderError, setSameFolderError] = useState(false);

    const [moveFolderOrFile, { loading }] = useMutation(MOVE_DIRECTORY_OR_FILE);

    const {
        data: dirData, loading: dirDetailsLoading,
    } = useQuery(GET_DIRECTORY_DETAILS, {
        variables: {
            dirId: currentDir,
        },
        fetchPolicy: 'no-cache',
    });

    // Making file and folder ids unique
    const updatedDirContents = dirData && dirData.DQgetDirDetails
        && dirData.DQgetDirDetails.dirContents
            .map(item => ({ ...item, originalId: item.id, id: `${item.id}_${item.type}` }));

    const filteredDirContents = updatedDirContents && updatedDirContents.filter(item => item.name !== 'Shared with me' && item.type !== 'file' && !filesToMove.includes(item.id));

    const breadcrumbContent = dirData && dirData.DQgetDirDetails && dirData.DQgetDirDetails.dirTree;

    const parentDir = dirData && dirData.DQgetDirDetails && dirData.DQgetDirDetails.dirId;

    const fileExporerBreadcrumb = (
        <Breadcrumb className="a-apply-theme-background-transparent">
            {breadcrumbContent && breadcrumbContent.map(item => (
                <BreadcrumbItem
                    key={item.dirId}
                    onClick={() => {
                        setCurrentDir(item.dirId);
                    }}
                >
                    <span className="appkiticon icon-folder-opened-fill" />
                    <span className="a-breadcrumb-item-text" style={{ fontSize: '0.9rem' }}>{item.dirName}</span>
                </BreadcrumbItem>
            ))}
        </Breadcrumb>
    );

    const fetchFolderData = data => {
        setSameFolderError(false);
        if (data.type === 'directory') {
            setCurrentDir(data.originalId);
        }
    };

    const fileSelectionChangeHandler = () => {
        //
    };

    const moveFileInput = [];

    filesToMove && filesToMove.forEach(file => {
        const result = oldFileExplorerDataSource && oldFileExplorerDataSource.find(element => element.id === file);
        if (result) {
            moveFileInput.push(result);
        }
    });

    const fileOrFolderInput = moveFileInput && moveFileInput.map(item => ({ id: item.originalId, type: item.type }));

    const onSave = async () => {
        if (loading) {
            return;
        }
        setSameFolderError(false);

        if (previousDir === parentDir) {
            setSameFolderError(true);
            return;
        }

        await moveFolderOrFile({
            variables: {
                dirId: previousDir,
                movedItems: fileOrFolderInput,
                targetDirId: parentDir,
            },
        }).then(() => {
            setToastMessage('Folders/Files are moved.');
        });
        setVisible(false);
        refreshFileExplorer();
    };

    return (
        <MoveFiles
            visible={visible}
            setVisible={setVisible}
            onSave={onSave}
            fileExplorerDataSource={filteredDirContents}
            selection={selection}
            setSelection={setSelection}
            selectAll={selectAll}
            setSelectAll={setSelectAll}
            fetchFolderData={fetchFolderData}
            dirDetailsLoading={dirDetailsLoading}
            fileSelectionChangeHandler={fileSelectionChangeHandler}
            fileExporerBreadcrumb={fileExporerBreadcrumb}
            sameFolderError={sameFolderError}
            loading={loading}
        />
    );
};

export default MoveFilesContainer;
